module.exports = __webpack_public_path__ + "img/af2fab4.jpg";